const warned = {};

export const deprecated = (oldname, newname, link) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  let message;

  message = `${oldname} is deprecated. Use ${newname} instead.`;

  if (link) {
    message += `\nYou can read more about it at ${link}`;
  }

  if (warned[message]) {
    return;
  }

  console.warn(`Warning: ${message}`);
  warned[message] = true;
};

export default deprecated;



// WEBPACK FOOTER //
// ./src/common/utils/deprecated.js